import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-itoohavetalent',
  templateUrl: './itoohavetalent.component.html',
  styleUrls: ['./itoohavetalent.component.scss']
})
export class ItoohavetalentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
